import { Avatar, Button } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../../App';
import db from '../../firebase';
import './TweetBox.css';

function TweetBox() {
    const [tweetMessage, setTweetMessage] = useState('');
    const [tweetImage, setTweetImage] = useState('');

    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const history = useHistory();

    const sendTweet = e => {
        e.preventDefault();
        db.collection('posts').add({
            displayName: loggedInUser.name,
            username: loggedInUser.name,
            verified: loggedInUser.verified,
            text: tweetMessage,
            image: tweetImage,
            avater: loggedInUser.image
        })
    }
    const signupRoute = () => {
        history.replace("/")
    }

    return (
        <div className="tweetBox">
            {loggedInUser.name ?
                <form>
                    <div className="tweetBox__input">
                        <Avatar src={loggedInUser.image} />
                        <input onChange={e => setTweetMessage(e.target.value)} value={tweetMessage} placeholder="What's happening?" type="text" />
                    </div>
                    <input onChange={e => setTweetImage(e.target.value)} value={tweetImage} className="tweetBox__imageInput" placeholder="Optional: Enter Images URL" type="text" />
                    <Button onClick={sendTweet} type="submit" className="tweetbox__tweetButton">Tweet</Button>
                </form>
                : <div className="widgets__signin">
                    <h2>New to Twitter?</h2>
                    <small>Sign up now to get your own personalized timeline!</small><br />
                    <Button onClick={signupRoute} variant="outlined">Sign up</Button>
                </div>
            }
        </div>
    )
}

export default TweetBox;
